﻿import * as Res from "./res";
import { getApiConfig } from "./context";
import { addScriptAsync } from "./addScript";

let loadGoogleMapApiPromise;

const callbackName = "googleMapsCallbackFn";

//
// import() won't work as it requires CORS headers in response.
// GMap does not provide one
//
function loadGoogleMapApiAsync(libraries) {
	let googleMaps = window.google && window.google.maps;
	if (!googleMaps) {
		if (!loadGoogleMapApiPromise) {
			const googleMapApiKey = window.GoogleMapApiKey || getApiConfig("gmapapikey");
			loadGoogleMapApiPromise = new Promise((resolve, reject) => {
				window[callbackName] = function () {
					delete window[callbackName];
					googleMaps = window.google && window.google.maps;
					resolve(googleMaps);
				};
				if (Array.isArray(libraries))
					libraries = libraries.join(",");
				addScriptAsync(`//maps.googleapis.com/maps/api/js?loading=async&v=quarterly&libraries=${encodeURIComponent(libraries)}&key=${encodeURIComponent(googleMapApiKey)}&callback=${callbackName}`).catch(reject);
			});
		}
		return loadGoogleMapApiPromise;
	}
	return googleMaps;
}

const getCurrentPositionAsync = "geolocation" in navigator ? (() => {
	let resultQueue;
	return () => {
		let needLocation = false;
		if (!resultQueue) {
			needLocation = true;
			resultQueue = [];
		}
		const p = new Promise((resolve, reject) => {
			resultQueue.push({ resolve, reject });
		});
		if (needLocation) {
			navigator.geolocation.getCurrentPosition(
				position => {
					const result = { lat: position.coords.latitude, lng: position.coords.longitude };
					resultQueue.forEach(({ resolve }) => resolve(result));
					resultQueue = null;
				},
				error => {
					let message;
					switch (error.code) {
						case 1:
							message = Res.getString("location.error.disabled");
							break;
						case 2:
							message = Res.getString("location.error.failed");
							break;
						case 3:
							message = Res.getString("location.error.timeout");
							break;
						default:
							message = error.message;
					}
					const err = new Error(message);
					resultQueue.forEach(({ reject }) => reject(err));
					resultQueue = null;
				}
			);
		}
		return p;
	};
})() : new Promise((_resolve, reject) => reject(new Error(Res.getString("location.error.not_supported"))));

export { loadGoogleMapApiAsync, getCurrentPositionAsync };